export default "__VITE_ASSET__Dr6Yfn$n__"